import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";

const RequireAuth: React.FC<{ children: ReactNode }> = ({ children }) => {
  const location = useLocation();
  const token = localStorage.getItem("token");
  const userRole = localStorage.getItem("role")?.toLowerCase();

  const isAdminRoute = location.pathname.startsWith("/admin");
  const isDoctorRoute = location.pathname.startsWith("/doctor");
  const isPatientRoute = location.pathname.startsWith("/patient") || location.pathname.startsWith("/dashboard");

  // Si pas de token, rediriger vers la page de login appropriée
  if (!token) {
    const redirectPath = isAdminRoute ? "/admin/login" : isDoctorRoute ? "/doctor/login" : "/login";
    return <Navigate to={redirectPath} replace state={{ from: location }} />;
  }

  // Vérifier que le rôle correspond à la route demandée
  // Si un admin essaie d'accéder aux routes doctor, le rediriger vers admin dashboard
  if (isAdminRoute && userRole !== "admin") {
    console.warn(`RequireAuth: User role '${userRole}' attempted to access admin route. Redirecting to appropriate dashboard.`);
    const redirectTo = userRole === "doctor" ? "/doctor/dashboard" : userRole === "patient" ? "/dashboard" : "/login";
    return <Navigate to={redirectTo} replace />;
  }

  // Si un doctor essaie d'accéder aux routes admin, le rediriger vers doctor dashboard
  if (isDoctorRoute && userRole !== "doctor") {
    console.warn(`RequireAuth: User role '${userRole}' attempted to access doctor route. Redirecting to appropriate dashboard.`);
    const redirectTo = userRole === "admin" ? "/admin/dashboard/accueil" : userRole === "patient" ? "/dashboard" : "/login";
    return <Navigate to={redirectTo} replace />;
  }

  // Si un patient essaie d'accéder aux routes admin/doctor, le rediriger vers patient dashboard
  if (isPatientRoute && userRole !== "patient") {
    console.warn(`RequireAuth: User role '${userRole}' attempted to access patient route. Redirecting to appropriate dashboard.`);
    const redirectTo = userRole === "admin" ? "/admin/dashboard/accueil" : userRole === "doctor" ? "/doctor/dashboard" : "/login";
    return <Navigate to={redirectTo} replace />;
  }

  // Si tout est correct, afficher le contenu
  return <>{children}</>;
};

export default RequireAuth;